import styled from "styled-components";
import { COLORS } from "../../../constants";

export const SearchInputContainer = styled.div`
  display: flex;
  padding: 10px 20px;
  align-items: center;
  gap: 10px;
  align-self: stretch;
  border-radius: 20px;
  background: ${COLORS.SECONDARY};
`;
export const SearchInput = styled.input`
  width: 100%;
  background: ${COLORS.SECONDARY};
  border: none;
  color: ${COLORS.WHITE};
  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  &::placeholder { color: ${COLORS.WHITE}; };
  &:focus {
          outline: none;
          box-shadow: 0px 0px 2px transparent;
      }
`;